//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
import RbBaseEditorialStickyBar from '../base-editorial-sticky-bar/base-editorial-sticky-bar.vue'
import { mapGetters, mapActions } from 'vuex'
import { ACTION_UPDATE_DASH_BUTTON_SMALL } from '@/scripts/store/actions'

const { viewTaskName, pagesWithStickyStoriesSlider } = wcs.getStoreConfig()
export default {
  extends: RbBaseEditorialStickyBar,
  props: {
    isStories: {
      type: Boolean,
      default: false,
    },
    centerChild: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    ...mapGetters(['isDashButtonSmall']),
    children() {
      return this.$slots?.default?.length
    },
    isLessThree() {
      return this.children <= this.centerChild
    },
    canBeSticky() {
      return pagesWithStickyStoriesSlider.includes(viewTaskName)
    },
  },
  watch: {
    scrollPosition(newVal, oldVal) {
      if (!this.isSticky) {
        return
      }

      if (newVal < oldVal) {
        this.updateDashButtonSmall(false)
      } else {
        this.updateDashButtonSmall(true)
      }
    },
  },
  methods: {
    ...mapActions({
      updateDashButtonSmall: ACTION_UPDATE_DASH_BUTTON_SMALL,
    }),
  },
}
